export const getUserMasterList = (store) => store.UserMaster.data;

export const getDoctorList = (store) => store.UserMaster.filters.doctor;

export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.UserMaster;
  return rest;
};
